/**
 * Default league identity so the draft assistant is usable with zero setup.
 *
 * Everything here can be overridden at runtime:
 *   - URL params:  ?league=<id>&user=<sleeper username>
 *   - Saved state: whatever the user last typed is persisted and wins on reload.
 */

export const DEFAULT_SLEEPER_LEAGUE_ID = '1384610162727211008';
export const DEFAULT_SLEEPER_USERNAME = 'doblerone';
export const DEFAULT_TEAM_NAME = 'Between The Lions';

/** Development / demo leagues for the in-week dashboard. */
export const SAMPLE_SLEEPER_LEAGUES = [
  {
    leagueId: '1384610162727211008',
    name: 'The League - Season 4',
    teamName: 'All You Need Is Love',
  },
  {
    leagueId: '1383653768192598016',
    name: 'Fantasy Futsal',
    teamName: "Kyren' Me Gofftly",
  },
  {
    leagueId: '1312163835284553728',
    name: 'Fantasy Futsal Dynasty',
    teamName: 'my name is jeff',
    note: 'SUPER_FLEX',
  },
];

export const SAMPLE_LEAGUE_IDS = SAMPLE_SLEEPER_LEAGUES.map((l) => l.leagueId);

const readParam = (key) => {
  try {
    return new URLSearchParams(window.location.search).get(key)?.trim() || '';
  } catch {
    return '';
  }
};

/** League ID to use before the user has typed anything: URL param, else the default. */
export const resolveDefaultLeagueId = () =>
  readParam('league') || DEFAULT_SLEEPER_LEAGUE_ID;

/** Sleeper username used to auto-pick "your team" in a league. */
export const resolveDefaultUsername = () => readParam('user') || DEFAULT_SLEEPER_USERNAME;

/** The shape leagueStorage persists, pre-filled with the defaults above. */
export const defaultLeaguesRecord = () => ({
  sleeper: {
    leagueId: resolveDefaultLeagueId(),
    managers: resolveDefaultUsername(),
  },
  espn: {},
  yahoo: {},
});
